(function () {
  // Font ∩ Mac Roman (223 characters). Trim as suggested earlier if you want a stricter set.
  var DISALLOWED = /[^ -~ -£¥§-¬®-±´-¸º-»¿-ÏÑ-ÖØ-Üß-ïñ-üÿıŒ-œŸƒˆ-ˇ˘-˝Ωπ–-—‘-‚“-„†-•…‰‹-›⁄€™∂∆∏∑√∞∫≈≠≤-≥◊ﬁ-ﬂ]/gu;

  function clean(s) {
  return s.normalize('NFC').replace(DISALLOWED, '');
}

function sanitise(input) {
  var v = input.value;
  var c = clean(v);
  if (c === v) return;

  // Keep the caret in the right place: clean only the text before it
  var caret = clean(v.slice(0, input.selectionStart)).length;
  input.value = c;
  input.setSelectionRange(caret, caret);
}

function attach(input) {
  if (input.dataset.fontSafeBound) return;
  input.dataset.fontSafeBound = '1';

  var composing = false;
  input.addEventListener('compositionstart', function () { composing = true; });
  input.addEventListener('compositionend', function () { composing = false; sanitise(input); });

  input.addEventListener('input', function () {
    if (!composing) sanitise(input);   // don't interrupt IME entry (Chinese, Japanese, etc.)
  });
}

  function init(root) {
    (root || document).querySelectorAll('[data-font-safe]').forEach(attach);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  // Re-bind when the theme editor or quick-view re-renders sections
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
